import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api/admin/code`;
const cfg = { withCredentials: true };

export const getCodeTree = () => axios.get(`${API}/tree`, cfg).then((r) => r.data);
export const getCodeFile = (path) =>
  axios.get(`${API}/file`, { ...cfg, params: { path } }).then((r) => r.data);
